import React from "react";
import PropTypes from "prop-types";
import { porcentaje, metricasPropTypes, COLOR_EAD, COLOR_RAD } from "./efectividadUtils.js";

// Resumen del global ponderado del dia seleccionado, con numerador y denominador a la vista.
export function ResumenGlobal(props) {
  const g = props.global;
  if (!g) {
    return null;
  }
  const detalleEad = g.ead_total !== null && g.ead_total !== undefined
    ? " (" + g.ead_atiempo + " a tiempo de " + g.ead_total + " guías con compromiso ese día)"
    : " (sin guías ese día)";
  const detalleRad = g.rec_total !== null && g.rec_total !== undefined
    ? " (" + g.rec_realizadas + " realizadas de " + g.rec_total + " agendadas)"
    : " (sin recolecciones ese día)";
  return (
    <div style={{ fontSize: "0.95rem", lineHeight: 1.9 }}>
      <span style={{ color: COLOR_EAD, fontWeight: "bold" }}>&#9632;</span>{" "}
      <b>EAD global: {porcentaje(g.ead)}</b>{detalleEad}
      <br />
      <span style={{ color: COLOR_RAD, fontWeight: "bold" }}>&#9632;</span>{" "}
      <b>Recolecciones global: {porcentaje(g.rad)}</b>{detalleRad}
    </div>
  );
}

ResumenGlobal.propTypes = {
  global: PropTypes.shape(metricasPropTypes)
};

// Explicacion fija de como se calcula cada indicador, para leer la grafica sin ayuda.
export function NotaEfectividad() {
  return (
    <div style={{ marginTop: 14, fontSize: "0.8rem", color: "#777", lineHeight: 1.6 }}>
      <b>Cómo se calcula.</b>{" "}
      <b>EAD</b> = guías entregadas a tiempo ÷ (entregadas a tiempo + entregadas tarde + pendientes cuya fecha
      compromiso era ese día).{" "}
      <b>Recolecciones</b> = recolecciones realizadas ÷ agendadas ese día (sin las canceladas).{" "}
      El <b>global</b> pondera todas las sucursales (suma de a tiempo ÷ suma de totales); no promedia porcentajes.{" "}
      Una sucursal sin barra no tuvo actividad ese día. Los valores se calculan cada madrugada y se guardan por día,
      por eso se puede elegir cualquier fecha del historial.
    </div>
  );
}
